/**
 * @description Link 開啟方式 (enum)
 */
export enum LinkTargetEnum {
  /** 原視窗 */
  Self = '0',
  /** 新視窗 */
  Blank = '1'
}
